import type { ItemProps } from './types'

export const calculateTotal = (products: ItemProps[]): number => {
  return Math.round(products.reduce((acc, product) => acc + product.quantity * product.donut.price, 0) * 100) / 100
}
